import { TFunction } from 'i18next'

/**
 * The "once" timing choices for an internal exam order, shared by the exam modal (VdgTestModal) and
 * the Daily Action Report's Do now, so both offer the same list with the same default.
 *
 * 0 is "within an hour" (the default), -1 is STAT (sent as 'ASAP'), anything else is hours.
 */
export const WITHIN_OPTIONS: number[] = [
  0,
  -1,
  ...Array.from(Array(25).keys()).slice(1),
  48,
  72,
  96,
  120,
  144,
  168,
]

export const DEFAULT_WITHIN = 0

export const withInLabel = (value: number | string, t: TFunction) => {
  if (String(value) === '-1') return t('examinations.asap')
  if (String(value) === '0') return t('examinations.withInHour')
  const hours = Number(value)
  if (hours > 24 && hours % 24 === 0) return `${hours / 24} d`
  return `${value} h`
}

/** The option as an exam plan's `withIn`. */
export const toWithIn = (value: number | string): number | 'ASAP' =>
  String(value) === '-1' ? 'ASAP' : Number(value)
